@if ((isLoggedIn$ | async)) {
  @if (showPoster) {
    <div (click)="playVideo()" class="thumbnail">
      <img [src]="(thumbnailUrl$ | async)" alt="no thumbnail" class="video-poster">
      <button class="play-button">&#9658;</button>
    </div>
  }
  @if (!showPoster) {
    <video #videoPlayer (ended)="onVideoEnd()" style="width: 100%; height: 100%;" controls
      controlsList="nodownload">
      <source [src]="(videoUrl$ | async)" type="video/mp4">
      Your browser does not support HTML video.
    </video>
  }
}